import switchFunc from 'lib/function/switchFunc'
import LineAwardIcon from 'components/Luxkit/Icons/line/LineAwardIcon'
import LineBanIcon from 'components/Luxkit/Icons/line/LineBanIcon'
import LineBedDoubleIcon from 'components/Luxkit/Icons/line/LineBedDoubleIcon'
import LineBedIcon from 'components/Luxkit/Icons/line/LineBedIcon'
import LineBusIcon from 'components/Luxkit/Icons/line/LineBusIcon'
import LineCalendarIcon from 'components/Luxkit/Icons/line/LineCalendarIcon'
import LineDollarSignAltIcon from 'components/Luxkit/Icons/line/LineDollarSignAltIcon'
import LineFileCheckAltIcon from 'components/Luxkit/Icons/line/LineFileCheckAltIcon'
import LineFileMinusAltIcon from 'components/Luxkit/Icons/line/LineFileMinusAltIcon'
import LineFilePlusAltIcon from 'components/Luxkit/Icons/line/LineFilePlusAltIcon'
import LineHeartPlusIcon from 'components/Luxkit/Icons/line/LineHeartPlusIcon'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import LineLocationPinAltIcon from 'components/Luxkit/Icons/line/LineLocationPinAltIcon'
import LineLuggageIcon from 'components/Luxkit/Icons/line/LineLuggageIcon'
import LinePlaneDepartureIcon from 'components/Luxkit/Icons/line/LinePlaneDepartureIcon'
import LinePlusCircleIcon from 'components/Luxkit/Icons/line/LinePlusCircleIcon'
import LineRestaurantIcon from 'components/Luxkit/Icons/line/LineRestaurantIcon'
import LineShieldCheckIcon from 'components/Luxkit/Icons/line/LineShieldCheckIcon'
import LineSyringeIcon from 'components/Luxkit/Icons/line/LineSyringeIcon'
import LineTicketIcon from 'components/Luxkit/Icons/line/LineTicketIcon'
import LineUsersAltIcon from 'components/Luxkit/Icons/line/LineUsersAltIcon'

const TOUR_V2_FINE_PRINT_CATEGORY_ICONS: Record<App.Tours.V2OfferFinePrintSection['title'], (props: any) => React.ReactElement> = {
  accommodation: LineBedDoubleIcon,
  booking: LineTicketIcon,
  cancellations: LineBanIcon,
  dates: LineCalendarIcon,
  exclusions: LineFileMinusAltIcon,
  food: LineRestaurantIcon,
  health: LineHeartPlusIcon,
  inclusions: LineFilePlusAltIcon,
  information: LineInfoCircleIcon,
  surcharges: LineDollarSignAltIcon,
  transport: LineBusIcon,
  travel: LinePlaneDepartureIcon,
  vaccination: LineSyringeIcon,
  destination: LineLocationPinAltIcon,
  baggage_restrictions: LineLuggageIcon,
  optional_extras: LinePlusCircleIcon,
}

export const getFinePrintSectionIcon = switchFunc(TOUR_V2_FINE_PRINT_CATEGORY_ICONS, LineInfoCircleIcon)

const TOUR_V2_FAQ_ITEM_ICONS: Record<string, (props: any) => React.ReactElement> = {
  'The operator': LineAwardIcon,
  'The accommodation': LineBedIcon,
  'The experience': LineFileCheckAltIcon,
  'The service': LineShieldCheckIcon,
  'The group': LineUsersAltIcon,
}

export const getFAQItemIcon = switchFunc(TOUR_V2_FAQ_ITEM_ICONS, LineInfoCircleIcon)
